import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

interface UploadResult {
  publicUrl: string;
  storagePath: string;
}

export function useBannerImageUpload() {
  return useMutation({
    mutationFn: async (file: File): Promise<UploadResult> => {
      if (!file.type.startsWith("image/")) {
        throw new Error("Seules les images sont acceptées (JPEG, PNG, WebP)");
      }
      if (file.size > 5 * 1024 * 1024) {
        throw new Error("L'image ne doit pas dépasser 5 Mo");
      }

      const ext = file.name.split(".").pop() ?? "png";
      const path = `banners/${Date.now()}-${crypto.randomUUID()}.${ext}`;

      const { error: uploadError } = await supabase.storage
        .from("banners")
        .upload(path, file, { upsert: false });

      if (uploadError) throw uploadError;

      const { data } = supabase.storage.from("banners").getPublicUrl(path);
      return { publicUrl: data.publicUrl, storagePath: path };
    },
    onError: (err: Error) => toast.error(`Upload échoué : ${err.message}`),
  });
}
